import { render, staticRenderFns } from "./ExamMultipleChoiceSimple.vue?vue&type=template&id=4535327b&"
import script from "./ExamMultipleChoiceSimple.vue?vue&type=script&lang=js&"
export * from "./ExamMultipleChoiceSimple.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports